import { BrandLogo } from 'shared/components/brand-logo'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'

interface HeaderLogoProps {
  href?: string
}

const logo = (
  <BrandLogo
    className="h-[35px] min-h-[35px] w-[35px] min-w-[35px] object-cover"
    loaderClassName="bg-text-secondary h-[35px] min-h-[35px] w-[35px] min-w-[35px] animate-pulse rounded-full"
  />
)

export function HeaderLogo({ href }: HeaderLogoProps) {
  if (!href) return logo

  return (
    <LinkWithoutPrefetch
      className="ring-background-secondary tab rounded-full ring-offset-0 focus:outline-hidden focus-visible:ring-2"
      href={href}
    >
      {logo}
    </LinkWithoutPrefetch>
  )
}
